// ©2024 Austin App House. All rights reserved.
import { isEmailValid } from '../../validators';
import { accountStatusOptions, accountTypeOptions } from '../../constans';

const validSelection = (selection, options) => selection !== null
  && typeof selection === 'object' && !Array.isArray(selection)
  && options.some(option => option.value === selection.value);

const contractorBankingInformationOnSubmit = (values = {}, initialValues = {}) => {
  const input = values || {};
  const result = {};
  // Saved numbers are returned masked. An unchanged placeholder is display-only;
  // the submit handler marks it clean so the server retains its encrypted value.
  const unchangedMask = (field, pattern) => typeof input[field] === 'string'
    && pattern.test(input[field]) && input[field] === initialValues?.[field];
  if (typeof input.email !== 'string' || !isEmailValid(input.email)) {
    result.email = 'Please enter valid Email';
  }
  if ((typeof input.routing !== 'string' || !/^\d{9}$/.test(input.routing))
    && !unchangedMask('routing', /^\*{7}\d{2}$/)) {
    result.routing = 'Routing number must be 9 digits';
  }
  if ((typeof input.account !== 'string' || !/^\d{4,17}$/.test(input.account))
    && !unchangedMask('account', /^\*{2,15}\d{2}$/)) {
    result.account = 'Account number must contain 4 to 17 digits';
  }
  if (!validSelection(input.accountType, accountTypeOptions)) {
    result.accountType = 'Please select Personal or Business';
  }
  if (!validSelection(input.accountStatus, accountStatusOptions)) {
    result.accountStatus = 'Please select Checking or Savings';
  }
  if (input.acceptTerms !== true) {
    result.acceptTerms = 'Please agree to terms & policies';
  }
  return result;
};

export default contractorBankingInformationOnSubmit;
